import { normalizeLibraryUiFolderPath } from './libraryPaths'

const STORAGE_KEY = 'glyphicai-library-selected-folder'

/** 上次在图库中选中的文件夹路径；根目录持久化为 '' */
export function readStoredLibraryFolderPath(): string {
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    if (typeof v !== 'string') return ''
    return normalizeLibraryUiFolderPath(v)
  } catch {
    return ''
  }
}

export function persistLibraryFolderPath(path: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, path)
  } catch {
    /* ignore */
  }
}
